module.exports = __webpack_public_path__ + "static/media/imac-scrn-user-testing-v2.ab28fdeb.jpg";